/* eslint-disable no-console */
import 'braid-design-system/reset'; // Must be first for Braid CSS reset
import { createRoot } from 'react-dom/client';
import { App } from './App/App';
import './i18n';
import { BrowserRouter } from 'react-router-dom';
import './styles/index.css';
import './styles/PrintPage.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Capture the PWA install prompt as early as possible — before React mounts.
// The beforeinstallprompt event can fire at any time; if React hasn't mounted
// yet, the hook's useEffect listener would miss it. Storing it globally
// ensures the hook can always pick it up.
window.__PWA_DEFERRED_PROMPT = null;
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__PWA_DEFERRED_PROMPT = e as any;
});

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
}

// Register service worker for PWA support
// This enables offline capabilities and makes the app installable
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // When a new version is available, notify the user
    const waitingWorker = registration.waiting;
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
    // Reload to get the latest version
    window.location.reload();
  },
  onSuccess: () => {
    console.log('[AIB Bank] App is ready for offline use!');
  },
});
